import React, { lazy } from 'react';

import { useTranslation } from '~/app';
import { Dialog, DialogContent, DialogDescription, DialogTitle } from '~/components/Dialog/Dialog';

/**
 * @author      Michael Hettmer <mail@michael-hettmer.de>
 * @copyright   2019 Plusbyte UG (haftungsbeschränkt)
 * @license     {@link https://plusbyte.de Plusbyte License}
 */

interface ForgotPasswordProps {
  modalOpen: boolean;
  onBackToLogin: () => void;
}

const ForgotPasswordFirebaseLazy = lazy(() => import('./ForgotPasswordFirebase'));

const ForgotPassword = ({ modalOpen, onBackToLogin }: ForgotPasswordProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Dialog open={modalOpen} onOpenChange={(open) => !open && onBackToLogin()}>
      <DialogContent size="md">
        <DialogTitle>{t('forgot_password_dialog_title')}</DialogTitle>
        <DialogDescription>{t('forgot_password_dialog_description')}</DialogDescription>

        <div className="mt-4">
          {typeof window !== 'undefined' && (
            <React.Suspense fallback={<div />}>
              <ForgotPasswordFirebaseLazy onBackToLogin={onBackToLogin} />
            </React.Suspense>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ForgotPassword;
